export const firstChildAltSelector = ':first-of-type:not(style):not(:first-of-type ~ *),style + *';
export var KEY_CODES;
(function (KEY_CODES) {
    KEY_CODES["ENTER"] = "Enter";
    KEY_CODES["ARROW_UP"] = "ArrowUp";
    KEY_CODES["ARROW_DOWN"] = "ArrowDown";
    KEY_CODES["ARROW_RIGHT"] = "ArrowRight";
    KEY_CODES["ARROW_LEFT"] = "ArrowLeft";
    KEY_CODES["ESCAPE"] = "Escape";
})(KEY_CODES || (KEY_CODES = {}));
export const equals = (a, b) => JSON.stringify(a) === JSON.stringify(b);
export function importedDefaultComponentShim(component) {
    if (component && typeof component === 'object' && 'default' in component) {
        return component.default;
    }
    else {
        return component;
    }
}
export const multiplyRemSize = (params) => {
    const { size, multiple } = params;
    const [value] = size.split('rem');
    return `${Number(value) * multiple}rem`;
};
